import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import FlagIcon from "vue-flag-icon";
import axios from "axios";
import store from "./store";
import i18n from "@/plugins/i18n";
import Swal from "sweetalert2";
import VueCookies from "vue-cookies";
import VueZxingScanner from "vue-zxing-scanner";
import Carousel3d from "vue-carousel-3d";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

Vue.prototype.$http = axios;
axios.defaults.headers.common["Content-Type"] = "application/json";

const token = localStorage.getItem("Token");
const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
if (token && isLoggedIn) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

let isTokenAlertShown = false;
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      handleTokenExpired("Session ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่");
    }
    return Promise.reject(error);
  },
);

async function handleTokenExpired(message) {
  if (isTokenAlertShown) return;
  isTokenAlertShown = true;

  try {
    document
      .querySelectorAll(
        ".v-dialog__content--active, .v-overlay, .v-overlay__scrim",
      )
      .forEach((el) => el.remove());
    document.body.classList.remove("overflow-y-hidden");

    store.commit("logout");
    Vue.$cookies.keys().forEach((k) => Vue.$cookies.remove(k));
    localStorage.removeItem("Token");
    localStorage.removeItem("isLoggedIn");
    delete axios.defaults.headers.common["Authorization"];

    await Swal.fire({
      title: "Session Expired",
      text: message,
      icon: "warning",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "ตกลง",
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: true,
    });

    const currentPath = router.currentRoute?.path || window.location.pathname;
    if (currentPath !== "/Login") {
      router.replace("/Login").catch(() => (window.location.href = "/Login"));
    }
  } catch (err) {
    window.location.href = "/Login";
  } finally {
    setTimeout(() => {
      isTokenAlertShown = false;
    }, 5000);
  }
}

window.$ = window.jQuery = require("jquery");
Vue.config.productionTip = false;
Vue.use(FlagIcon);
Vue.use(VueCookies);
Vue.use(VueZxingScanner);
Vue.use(Carousel3d);
new Vue({
  i18n,
  vuetify,
  store,
  router,
  Swal,
  render: (h) => h(App),
}).$mount("#app");
